import Alpine from 'alpinejs'

import intersect from '@alpinejs/intersect'

import Adds from './components/adds'
import DarkMode from './components/dark-mode'
import MobileBranding from './components/mobile-branding'

window.Alpine = Alpine

Alpine.plugin(intersect)

Alpine.data('adds', Adds)
Alpine.data('darkMode', DarkMode)
Alpine.data('mobileBranding', MobileBranding)

Alpine.start()
